/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "gasUsed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGasCostOfReadWithMemCache",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getGasCostOfReadWithMemory",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getGasCostOfReadWithStorage",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getGasCostOfSave",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        name: "points",
        outputs: [
            {
                internalType: "uint128",
                name: "liquidSum",
                type: "uint128",
            },
            {
                internalType: "int128",
                name: "liquidDelta",
                type: "int128",
            },
            {
                internalType: "uint256",
                name: "accFeeXOut_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accFeeYOut_128",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isEndpt",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class StorageGasTest__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
StorageGasTest__factory.bytecode = _bytecode;
StorageGasTest__factory.abi = _abi;
